import { Pipe, PipeTransform } from '@angular/core';
import { AccountTypeIdEnum } from '../../../models/transactions/enum/account-type-id.enum';

@Pipe({
  name: 'ipAffectedAccountCardName'
})
export class IpAffectedAccountCardNamePipe implements PipeTransform {
  transform(id: AccountTypeIdEnum | null | undefined): string {
    switch (id) {
      case AccountTypeIdEnum.ContributionAccount:
        return $localize`Affected Contribution Accounts:`;
      case AccountTypeIdEnum.VariableBenefitAccount:
        return $localize`Variable Benefit Account`;
      case AccountTypeIdEnum.AnnuityPensionAccount:
        return $localize`Annuity Account`;
      default:
        return '';
    }
  }
}
